const BI_EVENTS = {
  HOVER_ICON: '2',
  OPEN_FEED: '3',
  NOTIFICATION_SHOWN: '4',
  CARD_VIEWED: '5',
  CARD_CTA: '6',
  FOOTER_VIEWED: '7',
};

export { BI_EVENTS };
